import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Modal,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import { ArrowDropDown, Search } from "@mui/icons-material";
// import { serverUrl } from '../server';
import { getRequest, patchRequest, server } from "../config";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
const VerifyPartner = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [imageUrl, setimageUrl] = useState(null);
  const [profileTab, setProfileTab] = useState(0);
  const showModal = (partner) => {
    setSelectedPartner(partner);
    setProfileTab(0);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedPartner(null);
  };

  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage, selectedCity]);

  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCities = async () => {
    try {
      const uri = server.uri + "cities";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCities(citiesData);
        setbackData(citiesData);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchCities();
  }, []);
  const PatchUser=async(id,status)=>{
    try {
      const uri=server.uri+`users/${id}`
      const patch=await patchRequest(uri,{status:status})
     
     
    await fetchCustomers()
     setIsModalVisible(false)
     
    
    } catch (error) {
      console.log(error);
      
    }
  }
  const fetchCustomers = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { phone: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };
      let cityid = "";
      if (selectedCity && selectedCity.length > 0) {
        cityid = `,"city":${selectedCity},`;
        console.log(cityid);
      }
      if (selectedCity) {
        const response = await getRequest(
          `${server.uri}users?filter={
        "where":{
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}}
        
      ],"userType":"partner","city":"${selectedCity}","status":"pending"},"skip":"${filter.skip}",
        "limit":"${filter.limit}"
        ,"order":"createdAt desc"}`
        );
        //   console.log(response);

        setCustomers(response);
        const responseCount = await getRequest(
          `${server.uri}users/count?where={
        
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}}
      ],"userType":"partner","city":"${selectedCity}","status":"pending"}`
        );

        console.log(responseCount);

        setTotalCount(responseCount.count);
      } else {
        const response = await getRequest(
          `${server.uri}users?filter={
            "where":{
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}}
            
          ],"userType":"partner","status":"pending"},"skip":"${filter.skip}",
            "limit":"${filter.limit}"
            ,"order":"createdAt desc"}`
        );
        //   console.log(response);

        setCustomers(response);
        const responseCount = await getRequest(
          `${server.uri}users/count?where={
            
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}}
          ],"userType":"partner","status":"pending"}`
        );

        console.log(responseCount);

        setTotalCount(responseCount.count);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value);
    setPage(0); // Reset to the first page when city changes
  };

  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]; // Example city list
  return (
    <Container>
      <Typography variant="h4" sx={{ marginTop: 8, marginBottom: 2 }}>
        Pending For Approvals
      </Typography>
    
      {/* Search Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* Search Bar */}
        <TextField
          variant="outlined"
          placeholder="Search by name"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />

        {/* City Dropdown */}
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
          {/* <InputLabel>City</InputLabel> */}
          <Autocomplete
            value={actualValue}
            onChange={handleCityChange}
            // label="City"
            getOptionLabel={(option) => option?.name}
            options={allCities}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search City"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box>
        <Modal
          open={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          aria-labelledby="modal-title"
          style={{display:'flex',justifyContent:'center',alignItems:'center'}}
          aria-describedby="modal-description"
        >
          {imageUrl ? (<div style={{backgroundColor:'white',display:'flex',justifyContent:'flex-end',flexDirection:'column',alignItems:'flex-end',padding:'20px',borderRadius: '10px',}}>
            <div onClick={()=>setimageUrl(null)} style={{paddingBottom:'20px',cursor:'pointer'}}>
              <CloseIcon/>
            </div>
            <img style={{width:'800px',height:'500px'}} src={imageUrl}/>
            </div>
          ) : (
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 700,
                maxHeight: "80vh",
                bgcolor: "background.paper",
                borderRadius: '10px',
                boxShadow: 24,
                p: 4,
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div onClick={()=>setIsModalVisible(false)} style={{display:'flex',justifyContent:'space-between',cursor:'pointer'}}>
              <Typography id="modal-title" variant="h4" component="h2">
                Verify Partner
              </Typography>
              <CloseIcon/>
              </div>
              <Tabs value={profileTab} onChange={(e, newVal) => setProfileTab(newVal)} sx={{ mb: 2, mt: 1 }}>
                <Tab label="Verification" />
                <Tab label="Profile" />
              </Tabs>

              {profileTab === 0 && selectedPartner && (
                <>
                <table style={{marginTop:20,marginBottom:20}}>
                  <tr>
                    <td> <strong>Partner Name:</strong> </td>
                    <td>{selectedPartner.name}</td>
                  </tr>
                  <tr>
                    <td> <strong>Mobile Number</strong> </td>
                    <td>{selectedPartner.mobileNumber}</td>
                  </tr>
                  <tr>
                    <td> <strong>City</strong> </td>
                    <td>{selectedPartner.city}</td>
                  </tr>
                </table>
                  <Typography  variant="h5" sx={{ mt: 2,mb:2 }}>
                     Document Number:  {selectedPartner?.aadhaarCardNumber}
                   </Typography>
               <div style={{ display: "flex", flexDirection: "row", gap: 30 ,justifyContent:'space-between'}}>
                 <img
                 onClick={()=>setimageUrl(selectedPartner?.aadhaarCardUrl?.[0])}
                   style={{ height: "250px", width: "340px", cursor: "pointer" }}
                   src={selectedPartner?.aadhaarCardUrl?.[0]}
                 />
                 <img
                 onClick={()=>setimageUrl(selectedPartner?.aadhaarCardUrl?.[1])}
                   style={{ height: "250px", width: "340px", cursor: "pointer" }}
                   src={selectedPartner?.aadhaarCardUrl?.[1]}
                 />
               </div>
               {/* <Typography  variant="h5" sx={{ mt: 4,mb:2 }}>
                 Profile Picture
                   </Typography> */}
                   <div style={{ display: "flex", flexDirection: "row", gap: 30 ,justifyContent:'center'}}>
                  
                   {selectedPartner?.panCardUrl&&<div>
                   <Typography  variant="h5" sx={{ mt: 4,mb:2 }}>
                 Pan Card
                   </Typography>
                   <img
                 onClick={()=>setimageUrl(selectedPartner?.panCardUrl)}
                   style={{ height: "250px",width:'340px', cursor: "pointer" }}
                   src={selectedPartner?.panCardUrl}
                 />
                 </div>}
                   {selectedPartner?.userProfilePic&&<div>
                   <Typography  variant="h5" sx={{ mt: 4,mb:2 }}>
                 Profile Picture
                   </Typography>
                   <img
                 onClick={()=>setimageUrl(selectedPartner?.userProfilePic)}
                   style={{ height: "250px",width:'340px', cursor: "pointer" }}
                   src={selectedPartner?.userProfilePic}
                 />
                 </div>}
               </div>
               <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                 <Button onClick={() => setIsModalVisible(false)} sx={{ mr: 2 }}>
                   Deny
                 </Button>
                 <Button
                   variant="contained"
                   color="primary"
                   onClick={() => PatchUser(selectedPartner?.userId,'verified')}
                 >
                   Approve
                 </Button>
               </Box>
                </>
              )}

              {profileTab === 1 && selectedPartner && (
                <Box>
                  <table style={{marginTop:20,marginBottom:20}}>
                    <tr>
                      <td><strong>Partner Name:</strong></td>
                      <td>{selectedPartner.name}</td>
                    </tr>
                    <tr>
                      <td><strong>Mobile Number</strong></td>
                      <td>{selectedPartner.mobileNumber}</td>
                    </tr>
                    <tr>
                      <td><strong>City</strong></td>
                      <td>{selectedPartner.city}</td>
                    </tr>
                    <tr>
                      <td><strong>PinCode</strong></td>
                      <td>{selectedPartner.pincode}</td>
                    </tr>
                    <tr>
                      <td><strong>Status</strong></td>
                      <td>{selectedPartner.status}</td>
                    </tr>
                    <tr>
                      <td><strong>Address</strong></td>
                      <td>{selectedPartner.fullAddress}</td>
                    </tr>
                    <tr>
                      <td><strong>Wallet Balance</strong></td>
                      <td>₹{selectedPartner?.wallet?.toLocaleString("en-IN") || "0"}</td>
                    </tr>
                    <tr>
                      <td><strong>Joined At</strong></td>
                      <td>{moment(selectedPartner?.createdAt).format("DD-MM-YYYY")}</td>
                    </tr>
                    <tr>
                      <td><strong>Aadhar Card Number</strong></td>
                      <td>{selectedPartner?.aadhaarCardNumber}</td>
                    </tr>
                    <tr>
                      <td><strong>Pan Number</strong></td>
                      <td>{selectedPartner?.panNumber}</td>
                    </tr>
                  </table>

                  <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: "bold" }}>
                    Verification Photos
                  </Typography>
                  <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
                    {selectedPartner?.aadhaarCardUrl?.[0] && (
                      <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>Aadhaar Card (Front)</Typography>
                        <img
                          src={selectedPartner.aadhaarCardUrl[0]}
                          alt="Aadhaar Card Front"
                          style={{ width: "300px", height: "200px", objectFit: "cover", borderRadius: "8px", border: "2px solid #e0e0e0", cursor: "pointer" }}
                          onClick={() => setimageUrl(selectedPartner.aadhaarCardUrl[0])}
                        />
                      </Box>
                    )}
                    {selectedPartner?.aadhaarCardUrl?.[1] && (
                      <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>Aadhaar Card (Back)</Typography>
                        <img
                          src={selectedPartner.aadhaarCardUrl[1]}
                          alt="Aadhaar Card Back"
                          style={{ width: "300px", height: "200px", objectFit: "cover", borderRadius: "8px", border: "2px solid #e0e0e0", cursor: "pointer" }}
                          onClick={() => setimageUrl(selectedPartner.aadhaarCardUrl[1])}
                        />
                      </Box>
                    )}
                    {selectedPartner?.panCardUrl && (
                      <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>Pan Card</Typography>
                        <img
                          src={selectedPartner.panCardUrl}
                          alt="Pan Card"
                          style={{ width: "300px", height: "200px", objectFit: "cover", borderRadius: "8px", border: "2px solid #e0e0e0", cursor: "pointer" }}
                          onClick={() => setimageUrl(selectedPartner.panCardUrl)}
                        />
                      </Box>
                    )}
                    {selectedPartner?.userProfilePic && (
                      <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>Profile Picture</Typography>
                        <img
                          src={selectedPartner.userProfilePic}
                          alt="Profile"
                          style={{ width: "300px", height: "200px", objectFit: "cover", borderRadius: "8px", border: "2px solid #e0e0e0", cursor: "pointer" }}
                          onClick={() => setimageUrl(selectedPartner.userProfilePic)}
                        />
                      </Box>
                    )}
                    {!selectedPartner?.aadhaarCardUrl && !selectedPartner?.panCardUrl && !selectedPartner?.userProfilePic && (
                      <Typography variant="body2" color="textSecondary">No verification photos available</Typography>
                    )}
                  </Box>

                  <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: "bold" }}>
                    Past Work Photos
                  </Typography>
                  <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
                    {selectedPartner?.pastWorkPhotos && selectedPartner.pastWorkPhotos.length > 0 ? (
                      selectedPartner.pastWorkPhotos.map((photoUrl, index) => (
                        <Box key={index}>
                          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>Work Photo {index + 1}</Typography>
                          <img
                            src={photoUrl}
                            alt={`Past Work ${index + 1}`}
                            style={{ width: "300px", height: "200px", objectFit: "cover", borderRadius: "8px", border: "2px solid #e0e0e0", cursor: "pointer" }}
                            onClick={() => setimageUrl(photoUrl)}
                          />
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="textSecondary">No past work photos available</Typography>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Modal>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                {/* <TableCell sx={{ fontWeight: "bold" }}>Services</TableCell> */}
                <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Joined At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((customer) => (
                <TableRow key={customer.userId}>
                  <TableCell>{customer?.uniqueId}</TableCell>
                  <TableCell
                    onClick={() => showModal(customer)}
                    style={{ cursor: "pointer" }}
                  >
                    {customer?.name}
                  </TableCell>
                 
                  <TableCell>{customer?.mobileNumber}</TableCell>
                  <TableCell>{customer?.city}</TableCell>
                  <TableCell>{customer?.status}</TableCell>
                  <TableCell>
                    {moment(customer?.createdAt).startOf("hour").fromNow()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
       
        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
};

export default VerifyPartner;
